import './Snackbar.scss';

// available types: error, success, information

const Snackbar = ({ type, msg }) => (
  <div role="alert" className={`snackbar ${type}`}>
    <div className="snackbar-icon">
      <span className="emoji-container" />
    </div>
    <div className="snackbar-msg">{msg}</div>
  </div>
);

export default Snackbar;
